import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { HelmetProvider } from 'react-helmet-async';
import { 
  BrowserRouter ,
} from 'react-router-dom';

import App from './app';

Sentry.init({
  dsn: "https://351ccaa901f3efb22d15c2ff2f89be18@o4508937876013056.ingest.us.sentry.io/4508937877258240",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["https://jmdresources.blogdns.com/backend_api", /^\/api\//],
});

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
